import React from "react";
import DataTables from "views/admin/tables/system-prompts";
import SignIn from "views/auth/SignIn";
import { MdLock } from "react-icons/md";
import ProtectedComponent from "./constants/ProtectedComponent";

import {
  TbCurrentLocation,
  TbFileSettings,
  TbCode,
  TbActivity,
  TbQuestionMark,
  TbTerminal2,
  TbCodePlus,
  TbMail,
  TbVariable,
  TbMessagePlus,
  TbMessage,
  TbTemplate,
  TbPlane,
  TbPrompt,
  TbListCheck,
} from "react-icons/tb";
import { ROUTES } from "constants";
import DestinationTables from "views/admin/tables/destinations";
import ActivitiesTables from "views/admin/tables/activities";
import WebPromptsTables from "views/admin/tables/web-prompts";
import CountriesTables from "views/admin/tables/countries";
import FaqTables from "views/admin/tables/faq";
import PromptFragmentsTables from "views/admin/tables/prompt-fragments";
import SystemPromptTables from "views/admin/tables/new-system-prompts";
import ConfigModule from "views/admin/config";
import EmailTrigger from "views/admin/tables/email-trigger";
import PromptVariablesTables from "views/admin/tables/prompt-variables";
import MessagesTables from "views/admin/tables/messages";
import TemplateTable from "views/admin/tables/email-template/components/email-template-table/templateTable";
import TrackerTables from "views/admin/tables/email-tracker";
import OnBoardTable from "views/admin/tables/onboard-template/components/onboard-template-table/onBoardTable";

const routes = [
  {
    name: "Prompt",
    layout: ROUTES.legacyAdmin,
    icon: <TbCode className="h-6 w-6" />,
    path: "admin-prompt",
    component: (
      <ProtectedComponent allowedRoles={[1, 3]}>
        <DataTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1, 3],
  },
  {
    name: "System-Prompt",
    layout: ROUTES.legacyAdmin,
    icon: <TbPrompt className="h-6 w-6" />,
    path: "system-prompt",
    component: (
      <ProtectedComponent allowedRoles={[1, 3]}>
        <SystemPromptTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1, 3],
  },
  {
    name: "Prompt-fragments",
    layout: ROUTES.legacyAdmin,
    icon: <TbCodePlus className="h-6 w-6" />,
    path: "prompt-fragments",
    component: (
      <ProtectedComponent allowedRoles={[1, 3]}>
        <PromptFragmentsTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1, 3],
  },
  {
    name: "Prompt-variables",
    layout: ROUTES.legacyAdmin,
    icon: <TbVariable className="h-6 w-6" />,
    path: "prompt-variables",
    component: (
      <ProtectedComponent allowedRoles={[1, 3]}>
        <PromptVariablesTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1, 3],
  },
  {
    name: "Config",
    layout: ROUTES.legacyAdmin,
    path: "config",
    icon: <TbFileSettings className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <ConfigModule />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "Destinations",
    layout: ROUTES.legacyAdmin,
    path: "destinations",
    icon: <TbCurrentLocation className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <DestinationTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "Activities",
    layout: ROUTES.legacyAdmin,
    path: "activities",
    icon: <TbActivity className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <ActivitiesTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "Website-prompts",
    layout: ROUTES.legacyAdmin,
    path: "web-prompts",
    icon: <TbTerminal2 className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1, 3]}>
        <WebPromptsTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1, 3],
    secondary: true,
  },
  {
    name: "Countries",
    layout: ROUTES.legacyAdmin,
    path: "countries",
    icon: <TbPlane className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <CountriesTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "Send Email",
    layout: ROUTES.legacyAdmin,
    path: "send-email",
    icon: <TbMail className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <EmailTrigger />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "Email Tracker",
    layout: ROUTES.legacyAdmin,
    path: "email-tracker",
    icon: <TbMessagePlus className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <TrackerTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "FAQ",
    layout: ROUTES.legacyAdmin,
    path: "faq",
    icon: <TbQuestionMark className="h-6 w-6" />,
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <FaqTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
    secondary: true,
  },
  {
    name: "Message",
    layout: ROUTES.legacyAdmin,
    icon: <TbMessage className="h-6 w-6" />,
    path: "message",
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <MessagesTables />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
  },
  {
    name: "Email Templates",
    layout: ROUTES.legacyAdmin,
    icon: <TbTemplate className="h-6 w-6" />,
    path: "templates",
    component: (
      <ProtectedComponent allowedRoles={[1]}>
        <TemplateTable />
      </ProtectedComponent>
    ),
    allowedRoles: [1],
  },
  {
    name: "Onboarding Templates",
    layout: ROUTES.legacyAdmin,
    icon: <TbListCheck className="h-6 w-6" />,
    path: "onboarding",
    component: (
      <ProtectedComponent allowedRoles={[1, 4]}>
        <OnBoardTable />
      </ProtectedComponent>
    ),
    allowedRoles: [1, 4],
  },
  {
    name: "Sign in",
    layout: ROUTES.auth,
    path: "login",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];

export const getFilteredRoutes = (userRole) => {
  return routes.filter((route) => {
    if (route.public) return true;

    if (!userRole) return false;

    if (route.allowedRoles && route.allowedRoles.length > 0) {
      return route.allowedRoles.includes(userRole);
    }

    return false;
  });
};

export default routes;
